export const modules = {
	ACTIVITY: 'activity',
	API_USER: 'apiuser',
	APPLICATION: 'application',
	ASSIGNMENT: 'assignment',
	AUDIT_TRAIL: 'audittrail',
	AUTOMATION: 'automation',
	BUREAU: 'agency',
	CALCULATION_SCHEME: 'calculationscheme',
	CANDIDATE: 'candidate',
	CAO: 'cao',
	CAONEWS: 'caonews',
	CAOWAGES: 'caowages',
	CAO_CUSTOM_AGREEMENT: 'customcao',
	CAO_INSTANCE: 'caoinstance',
	CAO_WAGES_REQUEST: 'caowagesrequest',
	COMMENTS: 'comments',
	COMMUNITY: 'community',
	COMPONENT_MODEL: 'componentmodel',
	CONNECT: 'connect',
	CONTRACT: 'contract',
	CUSTOMER: 'customer',
	CUSTOMER_INVOICE: 'customerinvoice',
	CUSTOMER_INVOICE_COMPONENT: 'customerinvoicecomponent',
	CUSTOMER_SUBSCRIPTIONS: 'customersubscriptions',
	CUSTOM_CAO_INCTANCE: 'customcaoinstance',
	DEALS: 'deal',
	DOCUMENT: 'document',
	DOCUMENT_TEMPLATE: 'documenttemplate',
	DOMAIN_VALUE: 'domainvalue',
	EMAIL_SENDER_AUTH: 'emailsenderauth',
	EMPLOYER: 'employer',
	FLEX_NET_CUSTOMER: 'flexnetcustomer',
	FLEX_NET_HOST: 'flexnethost',
	FORMS: 'form',
	FORM_DESIGNER: 'formdesigner',
	FS_API_LOG: 'faspilog',
	ILLNESS: 'illness',
	INCOMING_MESSAGE: 'incomingmessage',
	INVOICE: 'invoice',
	JOB: 'job',
	JOBBOARD: 'jobboard',
	JOBBOARD_INSTANCE: 'jobboardinstance',
	JOB_POST: 'jobpost',
	LABEL: 'label',
	MODEL_MATRIX: 'modelmatrix',
	MODEL_MATRIX_INSTANCE: 'modelmatrixinstance',
	NEWS: 'news',
	NEWS_ADMIN: 'newsadmin',
	OUTGOING_MESSAGE: 'outgoingmessage',
	PAGE: 'page',
	PAYMENT: 'payment',
	PAYSLIP: 'payslip',
	PHASE: 'candidatephase',
	PROFORMA: 'proforma',
	RATE_CLASS: 'rateclass',
	RESERVATION: 'candidatereservation',
	ROLE: 'role',
	SAFETY: 'safety',
	SAVED_FILTER: 'savedfilter',
	SETTING: 'setting',
	SHARELOG: 'sharelog',
	SUBSCRIBER: 'subscriber',
	SUBSCRIPTION_SETTING: 'subscriptionsetting',
	SUPPLIER: 'supplierorganization',
	SURVEY: 'survey',
	SURVEY_ADMIN: 'surveyadmin',
	TAG: 'tag',
	TEMPLATE: 'template',
	TEST_CALCULATION_SCHEME: 'calculationscheme/commonclockwisetest',
	TEXT_MODEL: 'textmodel',
	TIMECARD: 'timecard',
	TRANSLATION: 'translation',
	USER: 'user',
	WML: 'wml',
	DASHBOARD: 'dashboard',
	CONNECTOR: 'plugin',
	PUBLIC_JOB: 'publicJob',
	PUBLIC_EMPLOYER: 'publicEmployer',
	PUBLIC_NEWS: 'publicNews',
};

export const modulesMetaData = {
	[modules.DASHBOARD]: {
		index: 'index',
	},
	[modules.BUREAU]: {
		list: 'list',
		detail: 'commondetails',
		structurePage: 'commonstructure',
	},
	[modules.EMPLOYER]: {
		list: 'list',
		detail: 'commondetails',
		contactPersonList: 'contactpersonlist',
		contactPersonCommonDetails: 'contactpersoncommondetails',
	},
	[modules.CANDIDATE]: {
		list: 'list',
		detail: 'commondetails',
		form: 'form',
	},
	[modules.ASSIGNMENT]: {
		list: 'list',
		detail: 'commondetails',
		form: 'form',
	},
	[modules.CONTRACT]: {
		list: 'list',
		detail: 'commondetails',
		bulkUpdateList: 'bulkupdaterequestlist',
		bulkUpdateDetail: 'bulkupdaterequestcommondetails',
	},
	[modules.DOCUMENT]: {
		list: 'list',
		setting: 'documentsettinglist',
		settingDetails: 'documentsettingcommondetails',
	},
	[modules.TIMECARD]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.DEALS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.INVOICE]: {
		list: 'list',
	},
	[modules.PAYSLIP]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.PHASE]: {
		list: 'list',
	},
	[modules.ILLNESS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.RESERVATION]: {
		list: 'list',
	},
	[modules.PAYMENT]: {
		list: 'list',
	},
	[modules.NEWS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.COMMENTS]: {
		list: 'list',
	},
	[modules.COMMUNITY]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.JOB]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.ACTIVITY]: {
		list: 'list',
		taskList: 'tasklist',
	},
	[modules.CAONEWS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CAO]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CAOWAGES]: {
		list: 'list',
		detail: 'details',
	},
	[modules.CAO_WAGES_REQUEST]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CAO_INSTANCE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CAO_CUSTOM_AGREEMENT]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CUSTOM_CAO_INCTANCE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.WML]: {
		list: 'list',
		detail: 'details',
	},
	[modules.APPLICATION]: {
		list: 'list',
		form: 'form',
		detail: 'commondetails',
	},
	[modules.JOBBOARD_INSTANCE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.JOBBOARD]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.JOB_POST]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SURVEY]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SURVEY_ADMIN]: {
		list: 'list',
		detail: 'commondetails',
		listOptOut: 'listoptout',
	},
	[modules.USER]: {
		list: 'list',
		detail: 'commondetails',
		login: 'login',
	},
	[modules.SUBSCRIBER]: {
		list: 'list',
	},
	[modules.ROLE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.INCOMING_MESSAGE]: {
		list: 'list',
		logList: 'loglist',
		detail: 'commondetails',
	},
	[modules.OUTGOING_MESSAGE]: {
		list: 'list',
		detail: 'commondetails',
		logList: 'loglist',
	},
	[modules.CONNECT]: {
		settings: 'settings',
	},
	[modules.API_USER]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.FS_API_LOG]: {
		logList: 'loglist',
	},
	[modules.CUSTOMER]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CUSTOMER_INVOICE_COMPONENT]: {
		list: 'list',
		logList: 'loglist',
	},
	[modules.CUSTOMER_INVOICE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CUSTOMER_SUBSCRIPTIONS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SUBSCRIPTION_SETTING]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.LABEL]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.TRANSLATION]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.TEMPLATE]: {
		list: 'list',
		detail: 'details',
	},
	[modules.PAGE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.TAG]: {
		list: 'list',
	},
	[modules.NEWS_ADMIN]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SAVED_FILTER]: {
		myList: 'mylist',
		systemList: 'systemlist',
		otherList: 'otherlist',
		logslist: 'logslist',
	},
	[modules.RATE_CLASS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.CALCULATION_SCHEME]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.DOMAIN_VALUE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.MODEL_MATRIX]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.MODEL_MATRIX_INSTANCE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.COMPONENT_MODEL]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.TEXT_MODEL]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.AUDIT_TRAIL]: {
		list: 'list',
	},
	[modules.SETTING]: {
		list: 'list',
	},
	[modules.FLEX_NET_HOST]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.FLEX_NET_CUSTOMER]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.DOCUMENT_TEMPLATE]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.FORM_DESIGNER]: {
		list: 'list',
		detail: 'details',
	},
	[modules.EMAIL_SENDER_AUTH]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.FORMS]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.PROFORMA]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SUPPLIER]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.AUTOMATION]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.SHARELOG]: {
		list: 'list',
		detail: 'details',
	},
	[modules.SAFETY]: {
		list: 'list',
	},
	[modules.CONNECTOR]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.PUBLIC_JOB]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.PUBLIC_EMPLOYER]: {
		list: 'list',
		detail: 'commondetails',
	},
	[modules.PUBLIC_NEWS]: {
		list: 'list',
		detail: 'commondetails',
	},
};
